import {Component} from '@angular/core';
import {OfficeLocationsService} from '../office-locations/office-locations.service';
import {DialogService} from '../../../services/dialog.service';
import {Globals} from '../../../globals';
import {MatDialog} from '@angular/material/dialog';
import {OrganizationsService} from '../organization-configuration/organizations-service';
import {ConfigurationService} from '../configuration.service';
import {StaticDataService} from '../../../services/static-data.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {ReportListModel} from '../../reports/models/ReportListModel.model';
import {ReportsService} from '../../reports/reports.service';
import {ReportModel} from '../../reports/models/ReportModel.model';
import {LetterTemplateListComponent} from './letter-template-list/letter-template-list.component';
import {LettersService} from '../../../services/letters.service';
import {LetterTemplateDataModel} from '../../../models/letters/letter-template-data.model';
import {Constants} from '../../../constants';
import {ReportCategory, ReportClass} from '../../../models/enum/report-ID-enum';
import { ReportsLetterSubstituteModel } from '../../reports/models/ReportsLetterSubstituteModel';

@Component({
    selector: 'app-reports-configuration',
    templateUrl: './reports-configuration.component.html',
    styleUrls: ['./reports-configuration.component.scss']
})
export class ReportsConfigurationComponent {

    clientList: any[];
    selectedClient: any;
    locationList: ClientLocationDataModel[];
    selectedLocation: ClientLocationDataModel;
    reportCategoryEnumItems: EnumValidValueItemModel[];
    reportClassEnumItems: EnumValidValueItemModel[];
    selectedEnumReportCategory: EnumValidValueItemModel;
    selectedEnumReportClass: EnumValidValueItemModel;
    selectedEnumReportCategoryID: string;
    blReportByCategorySelected: boolean;
    reports: ReportListModel[] = [];
    selectedReport: ReportModel;
    UserReport: ReportModel = new ReportModel();
    letterTemplateList: LetterTemplateDataModel[] = [];
    hasLetterSubstitute: boolean = false;
    LetterSubstitute: string = 'Select Template';
    LetterTemplateDataModel: LetterTemplateDataModel;
    isNewReport: boolean = false;

    constructor(private locService: OfficeLocationsService,
                private dialogService: DialogService,
                private globals: Globals,
                private reportService: ReportsService,
                private dialog: MatDialog,
                private organizationsService: OrganizationsService,
                private configurationService: ConfigurationService,
                private staticDataService: StaticDataService,
                private lettersService: LettersService,
                private snackBar: MatSnackBar) {
    }

    ngOnInit() {
        this.loadServiceData();
    }

    loadServiceData() {
        this.locService.getClients().subscribe(data => {
            this.clientList = data;
            if (this.clientList.length > 0) {
                // Try to locate current users client
                const client = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
                if (client) {
                    this.selectedClient = client;
                } else {
                    this.selectedClient = this.clientList[0];
                }
            }
            // Load Locations
            this.changeClient(this.selectedClient);
        }, err => {
            console.log(err);
        });

        this.reportCategoryEnumItems = this.staticDataService.getValidValueItemsByValidValueName('enumReportCategory');
        this.reportClassEnumItems = this.staticDataService.getValidValueItemsByValidValueName('enumReportClass');

        this.lettersService.getTemplates().subscribe((res) => {
            this.letterTemplateList = res;
        });

        this.reportService.getReports()
            .subscribe(response => {
                this.reports = response;
            }, err => {
                this.showMessage('Error', 'Error getting reports');
            });
    }

    onChangeClient(event) {
        const l = this.configurationService.checkIsDirty();
        if (l) {
            l.subscribe((res) => {
                if (res) {
                    this.changeClient(event.value);
                    return;
                }
            });
        } else {
            this.changeClient(event.value);
        }
    }


    openLetterTemplate() {
        const dialogRef = this.dialog.open(LetterTemplateListComponent, {
            width: '400px',
            height: '500px',
            panelClass: 'dialog',
            data: {
                LOCID: this.selectedLocation.LOCID,
                ReportID: this.selectedReport.ReportID,
                LetterSubstituteID:  this.selectedReport.LetterSubstituteID,
                letterTemplateList: this.letterTemplateList
            }
        }).afterClosed().subscribe((data) => {
            if (data) { // after, save Letter Substitute
              this.reports.find(x => x.ReportID === this.selectedReport.ReportID).LetterTemplateID = data.LetterTamplateID;
              this.LetterSubstitute = data.LetterName;
              this.selectedReport.LetterSubstituteID = data.LetterSubstitueID;
              this.showMessage('Success', 'Letter Substitute saved');
            }
        });
    }

    onChangeLocation(event) {
        const l = this.configurationService.checkIsDirty();
        if (l) {
            l.subscribe((res) => {
                if (res) {
                    this.changeLocation(event.value);
                    return;
                }
            });
        } else {
            this.changeLocation(event.value);
        }
    }

    changeClient(client: TdoClientConfigurationModel) {
        this.selectedClient = client;

        this.locService.getClientLocations(this.selectedClient.TDOCID).subscribe((ldata) => {
            this.locationList = ldata;

            if (this.locationList.length > 0) {
                const loc = this.locationList.find(p => p.LOCID.toString() === this.globals.LOCID);
                if (loc) {
                    this.selectedLocation = loc;
                } else {
                    this.selectedLocation = this.locationList[0];
                }
            }
        });
    }

    onReportSelected(report: ReportListModel, event: any) {
        if (event.isUserInput) {
            this.selectedReport = report;
            this.UserReport = report;
            this.isNewReport = false;
            if (this.UserReport.LetterTemplateID !== Constants.emptyGuid) {
                this.hasLetterSubstitute = true;
                this.LetterSubstitute = this.letterTemplateList.find(x => x.LetterTamplateID === this.UserReport.LetterTemplateID).LetterName;
            } else {
                this.hasLetterSubstitute = false;
                this.LetterSubstitute = 'Select Template';
            }
            // validate if user can edit
            this.isNewReport = this.UserReport.enumReportClassID ===  ReportClass.LettersOnly;
        }
    }

    onUserReportCategoryChange(event: any) {
        this.selectedEnumReportCategoryID = event.value.ValidValueItemId;
        this.selectedEnumReportCategory = event.value;
        this.UserReport = new ReportModel();
        this.blReportByCategorySelected = true;
    }

    onUserReportCategorySelect(event: any) {
        this.selectedEnumReportCategoryID = event.value.ValidValueItemId;
        this.selectedEnumReportCategory = event.value;
        this.UserReport.enumReportCategoryID = event.value.ValidValueItemId;
        this.blReportByCategorySelected = true;
    }

    get reportsByCategory() {
           return this.reports.filter(x => x.enumReportCategoryID === this.selectedEnumReportCategoryID && x.enumReportClassID !== ReportClass.UI).sort((a, b) => a.ReportOrderInCategory - b.ReportOrderInCategory);
    }

    getCategoryById(categoryId) {
        return this.reportCategoryEnumItems.find(p => p.ValidValueItemId === categoryId);
    }

    getClassById(classId) {
        return this.reportClassEnumItems.find(p => p.ValidValueItemId === classId);
    }

    changeLocation(location: ClientLocationDataModel) {
        this.selectedLocation = location;
    }

    onNew(event) {
        this.isNewReport = true;
        this.CreateNewReport();

    }

    CreateNewReport() {
        this.UserReport = new ReportModel();
        this.UserReport.enumReportClassID = ReportClass.LettersOnly;
        this.UserReport.enumReportCategoryID = ReportCategory.AccountRecevables;
    }


    onSave() {
        this.reportService.saveReportOnlyLetter(this.UserReport).subscribe(result => {
            if (result) {
                this.showMessage('Success', 'Information saved');
            }
        });
    }

    onLetterTemplateChange(event: any) {
        if(this.selectedReport.LetterTemplateID === Constants.emptyGuid){
            this.showMessage('Error', 'Please select a Letter Template');
            this.UserReport.isLetterTemplate = false;
            return;
        }

        this.UserReport.isLetterTemplate = event.checked;

        const LetterSubstitute = new ReportsLetterSubstituteModel();
        LetterSubstitute.LetterSubstitueID = this.selectedReport.LetterSubstituteID
        LetterSubstitute.LetterTemplateID = this.selectedReport.LetterTemplateID;
        LetterSubstitute.LOCID = this.selectedLocation.LOCID.toString();
        LetterSubstitute.ReportID = this.selectedReport.ReportID;
        LetterSubstitute.xauditDeleted = !event.checked;

        this.reportService.SaveLetterSubstitutions(LetterSubstitute).subscribe(response => {
            if (response) {
                this.showMessage('Success', 'Report Letter Substitute updated!');

            }
        }, err => {
            this.showMessage('Error', 'Error updating Letter Substitute');
        });
    }

    showMessage(type, message) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }
}
